import CardShow from '../results/cardShow'
export const ContactResultCard = ({ id, ...props }) => (
	<CardShow key={id} {...props} />
)
export default ContactResultCard